import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

export const Content = (props) => {
  const {
    children, isActive, noOverflowHidden, relativePosition,
  } = props;
  const contentOverflowClassName = noOverflowHidden ? '': 'collapse-content-overflow-hidden';
  const positionClassName = relativePosition ? 'collapse-content-position-relative' : '';
  const contentVisibilityClassName = isActive ? 'content-show' : 'content-hide';

  return (
    <div
      className={classNames(
      'collapse-content',
      contentOverflowClassName,
      positionClassName,
      contentVisibilityClassName
    )}
    >
      {children}
    </div>
  );
};
Content.propTypes = {
  isActive: PropTypes.bool.isRequired,
  children: PropTypes.node.isRequired,
  noOverflowHidden: PropTypes.bool,
  relativePosition: PropTypes.bool,
};

Content.defaultProps = {
  noOverflowHidden: false,
  relativePosition: false,
};

